import React, {Component} from 'react';
import PropTypes from 'prop-types';

import VScroll from 'src/core/gd-components/scrolling/custom-v-scroll/v-scroll';
import SearchInput from "core/gd-ui/search/search";
import GDLoadingBlock from "src/core/gd-components/loading/gd-loading-overlap/block/gd-loading-block";

import Classes from 'classnames';
import _ from 'lodash'

export default class GitSelectRepository extends Component {

    static propTypes = {
        repositories: PropTypes.array,

        onClick: PropTypes.func,
        onSelectRepository: PropTypes.func,
    }

    state = {
        searchString: ''
    }

    onSearchChange = (searchString) => {
        this.setState({
            searchString: searchString
        });
    };

    renderList() {

        let repositories = _.map(this.props.repositories, (repository=>({
                id      : repository.repositoryId,
                name    : repository.name,
                provider: 'github.com',
                icon    : 'i5-github-black',
                type    : 'repository'
            }
        )));

        if (this.state.searchString) {
            const searchString = this.state.searchString.toLowerCase();
            repositories = _.filter(repositories, r=>r.name.toLowerCase().includes(searchString))
        }

        return (
            <div className="list">
                {repositories.map((repository) => (
                    <div key={repository.id} className="list-item repository" onClick={() => this.props.onSelectRepository(repository.id)}>
                        <div className={Classes('icon', repository.icon)}/>
                        <div className="label">{repository.name}</div>
                    </div>
                ))}
            </div>
        )
    }

    render() {
        return (
            <div className="main" >
                {this.state.isLoading && <GDLoadingBlock /> }

                <div className="search">
                    <SearchInput onChange={this.onSearchChange} value={this.state.searchString} />
                </div>

                <VScroll containerClass="main-container">
                    {!this.state.isLoading && this.renderList()}
                </VScroll>
            </div>
        );
    }
}
